import React, { useEffect, useState, useCallback, useRef } from "react";
import Sidebar from "../src/components/sidebar/Sidebar";
import "../src/pages/Main/Main.css";
import QuestionInput from "../src/components/question-input/QuestionInput";
import Inspiration from "../src/components/inspiration/Inspiration";
import FadeHeader from "../src/components/fade-header/FadeHeader";
import UserQuestion from "../src/components/user-question/UserQuestion";
import useHealthCheck from "../src/hooks/healthCheck";
import MaintenancePage from "./pages/Maintenance/Maintenance";
import UserDashboard from "./components/user-dashboard/UserDashboard";
import AdminDashboard from "./components/admin-dashboard/AdminDashboard";
import NoAccessPage from "./components/no-access-page/NoAccessPage";
import { useNavigate as navigate } from "react-router-dom";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import ErrorPage from "./components/error-page/ErrorPage";
import { ErrorBoundary } from "react-error-boundary";
import { AI_BASE_URL, API_BASE_URL, APP_ENV } from "../src/config/index";
import IconArrowDown from "../src/common/icons/IconArrowDown";
import { ToastContainer } from "react-toastify";
import Error from "./components/alert/error";
import { getAuthorization } from "./api/Authorization";
import { getUserTokenScope } from "./api/auth";
import Loader from "./components/common/Loader";
import FloatingBanner from "./components/FloatingBanner/FloatingBanner";

// const App = () => {
const App = ({ token, user, lng }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [textInput, setTextInput] = useState("");
  const [discussions, setDiscussions] = useState([]);
  const [avatar, setAvatar] = useState("");
  const [type, setType] = useState("");
  const isHealthy = useHealthCheck();
  const [isInputDisabled, setIsInputDisabled] = useState(false);
  const [reviews, setReviews] = useState([]);
  const [isConfigLoaded, setConfigLoaded] = useState(false);
  const [error, setError] = useState(null);
  const [needsRating, setNeedsRating] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [model, setModel] = useState("gpt-4.1");
  const [customPrompt, setCustomPrompt] = useState("");
  const [conversation, setConversation] = useState(() => {
    // This function now runs only once on component mount.
    const savedConversationData = sessionStorage.getItem("conversationData");
    if (savedConversationData) {
      try {
        const { conversationId, userId: savedUserId } = JSON.parse(
          savedConversationData,
        );
        // The `user` object is passed as a prop, so we can check it here.
        if (user && user.id === savedUserId) {
          return conversationId;
        }
      } catch (e) {
        console.error("Error parsing saved conversation data:", e);
      }
    }
    return null; // Return null if no valid conversation is found for the current user.
  });
  const [refreshDiscussions, setRefreshDiscussions] = useState(false);
  const [userPause, setUserPause] = useState(false);
  const [bottom, setBottom] = useState(questions.length > 0);
  const [isLoading, setIsLoading] = useState(false);
  const sidebarRef = useRef(null);
  const [showScrollButton, setShowScrollButton] = useState(false);
  const [isWebSearchActive, setIsWebSearchActive] = useState(false);
  const [silos, setSilos] = useState(() => {
    // Initialize silos from session storage if available
    const savedSilos = sessionStorage.getItem("selectedSilos");
    if (savedSilos) {
      try {
        return JSON.parse(savedSilos);
      } catch (e) {
        console.error("Error parsing saved silos:", e);
        return [];
      }
    }
    return [];
  });
  const [loadingSilots, setLoadingSilots] = useState(true);
  const [userSilots, setUserSilots] = useState([]);
  const [floatingBanner, setFloatingBanner] = useState(false);
  const [silosModalTrigger, setSilosModalTrigger] = useState(0);

  // Wrapped setSilos function that also saves to session storage
  const handleSetSilos = useCallback(
    (newSilos) => {
      // Skip update if the silos are the same
      if (JSON.stringify(newSilos) === JSON.stringify(silos)) {
        return;
      }
      const isWebSearch =
        Array.isArray(newSilos) &&
        newSilos.length === 1 &&
        newSilos[0]?.name === "web_search";

      if (isWebSearch) {
        setIsWebSearchActive(true);
      }

      if (!isWebSearch) {
        sessionStorage.setItem("selectedSilos", JSON.stringify(newSilos));
      }

      setSilos(newSilos);
    },
    [silos],
  );

  const models = [
    "qwen-plus",
    "qwen-max",
    "gpt-4o-mini",
    "gemini-1.5-flash",
    "gemini-1.5-pro",
    "gpt-4o",
    "gpt-4.1",
    "gpt-4.1-mini",
    "o3-mini",
  ];
  // const [user, setUser] = useState({});
  // const [token, setToken] = useState("");
  // const [lng, setLng] = useState("");
  // const [scope, setScope] = useState("");
  // const getCookieValue = (cookieName) => {
  //   const match = document.cookie.match(
  //     new RegExp(`(^| )${cookieName}=([^;]*)`)
  //   );
  //   return match ? decodeURIComponent(match[2]) : null;
  // };

  // useEffect(() => {
  //   const cookieName = `ttp_auth_${APP_ENV}`;
  //   const fallbackKey = `${cookieName}_fallback`;

  //   const parseJSON = (value) => {
  //     try {
  //       return JSON.parse(value);
  //     } catch (err) {
  //       console.error("Error parsing JSON:", err);
  //       return null;
  //     }
  //   };

  //   const getAuthData = () => {
  //     const cookie = getCookieValue(cookieName);
  //     if (cookie) return parseJSON(cookie);

  //     const fallback = sessionStorage.getItem(fallbackKey);
  //     return fallback ? parseJSON(fallback) : null;
  //   };

  //   const redirectToAutoLogin = (token, user, lng) => {
  //     const params = new URLSearchParams({ token });
  //     if (user) params.append("user", user);
  //     if (lng) params.append("lng", lng);

  //     setTimeout(() => {
  //       window.location.replace(`/webview/autologin?${params.toString()}`);
  //     }, 1000);
  //   };

  //   const authData = getAuthData();

  //   if (authData) {
  //     setUser(authData);
  //     setToken(authData.token);
  //     setLng(authData.language || authData.lang || "fr");
  //     setScope(authData.scope);
  //     return;
  //   }

  //   const urlParams = new URLSearchParams(window.location.search);
  //   const token = urlParams.get("token");
  //   const user = urlParams.get("user");
  //   const lng = urlParams.get("lng");

  //   if (token) {
  //     console.warn("Cookies missing — redirecting to /webview/autologin...");
  //     if (!window.location.pathname.includes("/autologin")) {
  //       redirectToAutoLogin(token, user, lng);
  //     }
  //   } else {
  //     console.error("No valid authentication token found.");
  //     navigate("/login");
  //   }
  // }, []);

  useEffect(() => {
    if (user && user.id && token) {
      setLoadingSilots(true);
      const loadSilots = async () => {
        try {
          const silotsData = await getAuthorization(user, token);

          setUserSilots(silotsData);
        } catch (error) {
          console.error("Erreur lors du chargement des silots :", error);
          setUserSilots([]);
        } finally {
          setLoadingSilots(false);
        }
      };

      loadSilots();
    }
  }, [user?.id, token]);

  useEffect(() => {
    if (conversation && user?.id) {
      const conversationData = {
        conversationId: conversation,
        userId: user.id,
      };
      sessionStorage.setItem(
        "conversationData",
        JSON.stringify(conversationData),
      );
    } else {
      // When there's no conversation, remove it from storage
      sessionStorage.removeItem("conversationData");
    }
  }, [conversation, user?.id]);

  useEffect(() => {
    // If a conversation ID was restored from session storage,
    // trigger the click handler to load its data.
    if (conversation && token && user?.id) {
      // Check if questions are empty to avoid re-fetching on hot-reload
      if (questions.length === 0) {
        handleConvoClick(conversation);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, user?.id]); // Run only when user/token becomes available

  const handleChange = (event) => {
    setModel(event.target.value);
  };

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
    setShowButton(false);
  };

  useEffect(() => {
    const ipp25 = userSilots.find((s) => s.id === 6);

    if (ipp25?.expireAt && !ipp25.expired) {
      const expireDate = new Date(ipp25.expireAt);
      const now = new Date();
      const timeDiff = expireDate.getTime() - now.getTime();
      const daysRemaining = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

      if (daysRemaining <= 30) {
        const sellingUrl = ipp25.sellingUrl;
        const buttonLabel = "Acheter le Manuel IPP-A.I. 2025";

        const message = ipp25.freeAccess
          ? "Accès gratuit au Manuel IPP-A.I. 2025 pendant 1 mois via TwinnTax."
          : "Votre accès au Manuel IPP-A.I. 2025 expire bientôt.";

        setFloatingBanner({
          message,
          url: sellingUrl,
          buttonText: buttonLabel,
        });
      }
    }
  }, [userSilots]);

  const fetchDiscussions = useCallback(async () => {
    try {
      const response = await fetch(`${AI_BASE_URL}/conversations/user`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      const processedData = processChat(data);
      setDiscussions(processedData);
    } catch (error) {
      console.error("Error fetching discussions:", error);
    }
  }, [token, user?.id]);

  const fetchConversationReviews = async (conversationId) => {
    try {
      const response = await fetch(
        `${AI_BASE_URL}/conversations/${conversationId}/reviews`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (!response.ok) {
        throw new Error(
          `Failed to fetch reviews for conversation ${conversationId}: ${response.status}`,
        );
      }

      const reviewsData = await response.json();
      return reviewsData;
    } catch (error) {
      console.error("Error fetching conversation reviews:", error);
      return null;
    }
  };
  useEffect(() => {
    const fetchAvatar = async () => {
      if (!token || !user?.id) {
        console.warn("Token or User ID is missing—fetch aborted.");
        return;
      }

      try {
        const response = await fetch(
          `${API_BASE_URL}/organization/user?access_token=${token}&filter=[%7B%22property%22:%22id%22,%22value%22:${user.id},%22operator%22:%22eq%22%7D]&fields=avatar`,
          {
            method: "GET",
          },
        );

        const data = await response.json();
        if (data.data && data.data.length > 0) {
          setAvatar(data.data[0].avatarUrl);
        } else {
          console.warn("Avatar data not found.");
        }
      } catch (error) {
        console.error("Error fetching avatar:", error);
      }
    };

    if (token && user?.id) {
      fetchAvatar();
      fetchDiscussions();
    }
  }, [token, user]);

  useEffect(() => {
    if (refreshDiscussions) {
      fetchDiscussions();
      setRefreshDiscussions(false);
    }
  }, [refreshDiscussions, fetchDiscussions]);
  const processChat = (chat_history) => {
    return Object.entries(chat_history).reduce(
      (result, [key, records]) => {
        const categoryMap = {
          recent: "recent",
          same_day: "sameDay",
          yesterday: "yesterday",
          last_7_days: "last7days",
          last_30_days: "last30days",
          older: "others",
        };

        const category = categoryMap[key];

        if (category) {
          result[category] = records.map(({ id, title }) => ({ id, title }));
        }

        return result;
      },
      {
        recent: [],
        sameDay: [],
        yesterday: [],
        last7days: [],
        last30days: [],
        others: [],
      },
    );
  };

  const createNewConversation = async (title) => {
    try {
      const newConversation = {
        title: title,
        user_id: user.id,
        reviews: [],
      };

      const response = await fetch(`${AI_BASE_URL}/conversations`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(newConversation),
      });

      if (!response.ok) {
        throw new Error(
          `Failed to create a new conversation: ${response.status}`,
        );
      }

      const conversationData = await response.json();
      setConversation(conversationData);
      setRefreshDiscussions(true);
      return conversationData.id;
    } catch (error) {
      console.error("Error creating a new conversation:", error);
      return null;
    }
  };

  const handleSend = async () => {
    setIsInputDisabled(true);
    setBottom(true);
    setIsLoading(true);
    if (textInput.trim() && !isInputDisabled) {
      try {
        let conversationId = conversation; // Use conversation directly as the ID

        // Check if there is no active conversation
        if (!conversationId) {
          // Create a new conversation and get its ID
          conversationId = await createNewConversation(textInput.trim());
          if (!conversationId) {
            console.error("Failed to create a new conversation.");
            setIsLoading(false);
            return;
          }

          // Set the new conversation globally
          setConversation(conversationId);
        }

        // Add the new question to the state with the conversation ID
        const newQuestion = {
          question: textInput.trim(),
          reviews: null,
          tempId: Date.now() + Math.random(), // Add a unique tempId for new questions
        };

        setQuestions((prevQuestions) => [...prevQuestions, newQuestion]);
        setBottom(true);
        setTextInput(""); // Clear the input field

        // Scroll to the bottom of the page
        setTimeout(() => {
          window.scrollTo({
            top: document.documentElement.scrollHeight - 10,
            behavior: "smooth",
          });
        });
      } catch (error) {
        console.error("Error sending question:", error);
      } finally {
        setIsLoading(false);
        handleReviewCreated();
      }
    } else {
      console.warn("Cannot send an empty question or input is disabled.");
    }
  };

  const handleInspirationClick = async (question) => {
    setBottom(true);
    setIsLoading(true);
    if (question.trim()) {
      try {
        // Create a new conversation using the inspiration question as the title
        const conversationId = await createNewConversation(question.trim());
        if (!conversationId) {
          console.error("Failed to create a new conversation for inspiration.");
          setIsLoading(false);
          return;
        }

        // Add the inspiration question to the state with the new conversation ID
        const newQuestion = {
          question: question.trim(),
          reviews: null,
          tempId: Date.now() + Math.random(), // Add a unique tempId for new questions
        };

        setConversation(conversationId); // Set the new conversation globally
        setQuestions([newQuestion]); // Reset questions to only include the new question
      } catch (error) {
        console.error("Error handling inspiration click:", error);
      } finally {
        setIsLoading(false);
      }
    } else {
      console.warn("Cannot add an empty inspiration question.");
    }
  };

  const handleConvoClick = async (id) => {
    if (window.innerWidth <= 1024) {
      toggleSidebar();
    }
    setIsInputDisabled(true);
    setIsLoading(true); // Activate loading state

    // If the questions are not loaded, we should proceed to fetch them,
    // even if the conversation ID is already set (e.g., on page refresh).
    if (id === conversation && questions.length > 0) {
      setIsLoading(false); // Already loaded, just stop loading indicator
      return; // And do nothing else
    }

    // Clear previous state only if it's a different conversation
    if (id !== conversation) {
      handleNewDiscussion();
    }

    setBottom(true);
    setConversation(id); // This will trigger the useEffect to save to sessionStorage
    try {
      const response = await fetch(
        `${AI_BASE_URL}/conversations/${id}/reviews`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (!response.ok) {
        throw new Error(
          `Failed to fetch reviews for conversation ${id}: ${response.status}`,
        );
      }

      const reviewsData = await response.json();

      const updatedQuestions = reviewsData.map((review) => ({
        question: review.question, // Extract the question
        reviews: review, // Pass the rest of the review data
        tempId: undefined, // No tempId for loaded reviews
      }));

      setQuestions(updatedQuestions); // Update the questions state
    } catch (error) {
      console.error("Error fetching reviews:", error);
    } finally {
      setIsLoading(false); // Stop loading after fetch is complete
    }
  };

  const handleRatingComplete = () => {
    setIsInputDisabled(false);
  };

  // Add error boundary
  const handleError = (error) => {
    setError(error.message || "Une erreur inattendue s'est produite.");
  };

  const errorFallback = ({ error, resetErrorBoundary }) => (
    <ErrorPage
      message={error.message || "Une erreur inattendue s'est produite"}
      onRetry={resetErrorBoundary}
    />
  );

  const handleRatingRequired = (record) => {
    if (record && record.id) {
      handleReviewCreated();
      setNeedsRating(true);
      setCurrentRecord(record);
      setIsInputDisabled(true);
    }
  };
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      // Affiche le bouton si on n'est pas proche du bas
      setShowScrollButton(scrollTop < documentHeight - windowHeight - 200);
    };

    window.addEventListener("scroll", handleScroll);

    // Vérifie au premier rendu aussi
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  };
  const handleRatingSubmit = async (rating) => {
    try {
      await axios.patch(
        `${AI_BASE_URL}/reviews/${currentRecord.id}`,
        { rating },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setNeedsRating(false);
      setCurrentRecord(null);
      setIsInputDisabled(false);
    } catch (error) {
      console.error("Error updating review:", error);
    }
  };

  const handleSkipRating = () => {
    setNeedsRating(false);
    setCurrentRecord(null);
    setIsInputDisabled(false);
  };

  if (isHealthy === null) {
    return <div></div>;
  }

  // Show loading while silos are being fetched
  if (isHealthy && loadingSilots) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          background: "#ffffff",
        }}
      >
        <Loader />
      </div>
    );
  }

  // Check if user has no access to any silos
  const isOnlyExpiredGeneral =
    Array.isArray(userSilots) &&
    userSilots.length === 1 &&
    userSilots[0].label === "General" &&
    userSilots[0].expired === true;
  const allSilosExpiredOrMissing =
    !silos ||
    silos.length === 0 ||
    silos.every((s) => typeof s === "object" && s.expired);

  if (
    isHealthy &&
    !loadingSilots &&
    (userSilots.length === 0 || isOnlyExpiredGeneral)
  ) {
    return (
      <ErrorBoundary
        FallbackComponent={errorFallback}
        onReset={() => window.location.reload()}
      >
        <ToastContainer style={{ zIndex: 20000 }} />
        <NoAccessPage token={token} />
      </ErrorBoundary>
    );
  }

  const handleNewDiscussion = () => {
    if (window.innerWidth <= 1024 && isOpen) {
      toggleSidebar();
    }
    setQuestions([]);
    setTextInput("");
    setConversation(null);
    handleSkipRating();
    setBottom(false);
  };

  const handleReviewCreated = () => {
    setRefreshDiscussions(true);
  };
  const handleDelete = async (id) => {
    try {
      // Step 1: Make the DELETE request to the API
      const response = await fetch(`${AI_BASE_URL}/conversations/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      // Step 2: If successful, update discussions and handle current conversation
      if (response.ok) {
        // Remove the deleted conversation from all categories in discussions
        setDiscussions((prev) => {
          const updated = {};
          for (const [cat, convos] of Object.entries(prev)) {
            updated[cat] = convos.filter((c) => c.id !== id);
          }
          return updated;
        });

        if (id === conversation) {
          handleNewDiscussion();
        }
      } else {
        console.error("Failed to delete discussion.");
      }
    } catch (error) {
      console.error("Error deleting discussion:", error);
    }
  };

  return (
    <ErrorBoundary
      FallbackComponent={errorFallback}
      onReset={() => window.location.reload()}
    >
      <ToastContainer style={{ zIndex: 20000 }} />

      {isHealthy ? (
        <div className="Main">
          <Sidebar
            isOpen={isOpen}
            toggleSidebar={toggleSidebar}
            userId={user?.id}
            discussions={discussions}
            handleSend={handleConvoClick}
            handleNewDiscussion={handleNewDiscussion}
            fetchDiscussions={fetchDiscussions}
            currentConversationId={conversation}
            refreshDiscussions={refreshDiscussions}
            setRefreshDiscussions={setRefreshDiscussions}
            handleDelete={handleDelete}
          />
          {floatingBanner && (
            <FloatingBanner
              message={floatingBanner.message}
              url={floatingBanner.url}
              buttonText={floatingBanner.buttonText}
              onClose={() => setFloatingBanner(null)}
            />
          )}
          <div
            className={`content ${isOpen ? "open" : ""} ${
              bottom ? "bottom" : ""
            }`}
          >
            <div className="user-question-header"></div>
            <FadeHeader
              isOpen={isOpen}
              showButton={showButton}
              setShowButton={setShowButton}
              toggleSidebar={toggleSidebar}
              handleNewDiscussion={handleNewDiscussion}
            />
            {!bottom && (
              <h1 style={{ marginBottom: "40px" }}>
                Comment puis-je vous aider aujourd'hui ?
              </h1>
            )}
            <QuestionInput
              text={textInput}
              setTextInput={setTextInput}
              handleSend={handleSend}
              bottom={bottom}
              isOpen={isOpen}
              setType={setType}
              disabled={isInputDisabled}
              showRating={needsRating}
              record={currentRecord}
              onRatingSubmit={handleRatingSubmit}
              onSkipRating={handleSkipRating}
              setCustomPrompt={setCustomPrompt}
              user={user}
              userSilots={userSilots}
              loadingSilots={loadingSilots}
              handleSetSilos={handleSetSilos}
              silos={silos}
              allSilosExpiredOrMissing={allSilosExpiredOrMissing}
              token={token}
              silosModalTrigger={silosModalTrigger}
            />
            {!bottom && (
              <>
                <h2>Besoin d'inspiration :</h2>
                <div className="inspirations">
                  {[
                    "Faut-il établir une seule attestation par enfant ?",
                    "Existe-t'il des outils d'aide pour utiliser facilement l'application Belcotax-on-web ?",
                    "c'est quoi mode d'emploi dans le Manuel de procédures internes en matière d'antiblanchiment",
                  ].map((question, index) => (
                    <Inspiration
                      key={index}
                      question={question}
                      handleSend={() => handleInspirationClick(question)}
                      allSilosExpiredOrMissing={
                        allSilosExpiredOrMissing || isOnlyExpiredGeneral
                      }
                    />
                  ))}
                </div>
              </>
            )}

            {isLoading ? (
              <div className="loading-bar-container">
                <div className="loading-bar"></div>
              </div>
            ) : (
              questions.map((item) => (
                <UserQuestion
                  conversation={conversation}
                  key={item.reviews?.id || item.tempId}
                  question={item.question}
                  review={item.reviews}
                  user={user}
                  token={token}
                  lng={lng}
                  setTextInput={setTextInput}
                  avatar={avatar}
                  type={type}
                  onChatPosted={fetchDiscussions}
                  onRatingComplete={handleRatingRequired}
                  setInputDisabled={setIsInputDisabled}
                  model={model}
                  customPrompt={customPrompt}
                  onReviewCreated={handleReviewCreated}
                  silos={silos}
                  isWebSearchActive={isWebSearchActive}
                  handleNewDiscussion={handleNewDiscussion}
                  onOpenSilosModal={() =>
                    setSilosModalTrigger((prev) => prev + 1)
                  }
                  userSilots={userSilots}
                />
              ))
            )}
            {/* {user.id == 8650 && <div>
      <select className="model-select" value={model} onChange={handleChange}>
        {models.map((model) => (
          <option key={model} value={model}>{model}</option>
        ))}
      </select>
    </div>} */}
            {showScrollButton && (
              <button className="scroll-down-btn" onClick={scrollToBottom}>
                <IconArrowDown />
              </button>
            )}
            {[8650, 8900, 469705].includes(user?.id) ? (
              <AdminDashboard token={token} user={user} />
            ) : (
              <UserDashboard userId={user?.id} token={token} user={user} />
            )}
          </div>
        </div>
      ) : (
        <MaintenancePage />
      )}
    </ErrorBoundary>
  );
};

export default App;
